export default function Timeline({ children }: { children: React.ReactNode }) {
  return (
    <div className="mx-auto px-6 py-8">
      <div className="relative ml-4">
        {/* Timeline line */}
        <div className="absolute inset-y-0 left-0 border-l-2" />
        {children}
      </div>
    </div>
  )
}
